import { useState } from "react";
import RenderFields from "./RenderFields";
import { Toggle } from "@usitsdasdesign/dds-react";
import Text from "atoms/Text";
function CallSupportHour({
    className = "",
    control,
    register,
    setValue,
    watch,
    errors,
    baseName = "",
}) {
    const fieldName = (field) => baseName ? `${baseName}.${field}` : field;
    const callSupportValue = watch(fieldName('callSupportType'));

    const fields = [
        {
            id: 2,
            type: 'radio-group',
            name: fieldName('callSupportType'),
            title: '',
            placeholder: '',
            isRequired: true,
            isDisabled: false,
            direction: 'row',
            radiobuttonItems: [
                {
                    value: 'full_day',
                    label: 'Full day',
                    isActive: callSupportValue === 'full_day',
                    isDisabled: false
                },
                {
                    value: 'half_day',
                    label: 'Half day',
                    isActive: callSupportValue === 'half_day',
                    isDisabled: false
                }
            ]
        },
    ];


    return (
        <div className={`flex items-center flex-wrap lg:flex-nowrap py-2 px-4 bg-[#E4E4E4] border border-grey-500 gap-3 justify-between ${className}`}>
            <div className='flex flex-wrap gap-2'>
                <Text variant="body" className="text-black">Support hrs<span className="text-red-900">*</span> :</Text>
                <RenderFields
                    fields={fields}
                    control={control}
                    register={register}
                    errors={errors}
                    setValue={setValue}
                    watch={watch}
                    gap='gap-4 pt-1'
                    grid=''
                />
            </div>
        </div>
    );
}


export default CallSupportHour;